import { CancelToken } from 'axios'

import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils/axios'

import { CustomerInvoice, State } from 'Portals/Customer/entities'

import { baseUrl } from './constants'

export const getList = (params: TableUrlParams): Promise<ListData<CustomerInvoice.Basic>> =>
	Http.get(baseUrl, { params })

export const retrieveStates = (): Promise<State[]> => Http.get(`${baseUrl}/states`)

export const downloadInvoiceDoc = (fileName: Key): Promise<Blob> =>
	Http.get(`${baseUrl}/download`, {
		responseType: 'blob',
		params: { fileName }
	})

export const searchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<CustomerInvoice.Search.Result> =>
	Http.get(`${baseUrl}/invc-id-search-suggestions`, { params, cancelToken })

export const citySearchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<string[]> => Http.get(`${baseUrl}/cities-search-suggestions`, { params, cancelToken })
